import moment from 'moment-timezone';
export const CHART_HEIGHT = 1000;
export const CHART_ZOOM = 0.8;
export const DROP_OFF_DISPLAY_NAME = '[Conviva]Other Unfiltered Events';
export const OTHERS_NODE_DISPLAY_NAME = '[Conviva]Other';
export const NOT_AVAILABLE_COLOR = '#e3e3e3';
export const LANDING_EVENTS_WITH_MAX_DIMENSION_RULES_COUNT = 3;
export const DURATION_ALLOWED_IN_DAYS = 14;

export const topNodesOption = [
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
  { label: '13', value: 13 },
  { label: '14', value: 14 },
  { label: '15', value: 15 },
  { label: '16', value: 16 },
  { label: '17', value: 17 },
  { label: '18', value: 18 },
  { label: '19', value: 19 },
  { label: '20', value: 20 },
];

export const stepOption = [
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
];

export const TIME_PICKER_REMINDING_MESSAGE =
  'Please ensure the end time is within 15 days of the start time.';

export const defaultCalenderBoundry = {
  start_time: moment().subtract(13, 'days').startOf().valueOf(),
  end_time: moment().endOf().valueOf(),
};
